import React from 'react';
import './PlayerSearchOptionLink.css';
import type { PlayerSearchOption } from '../../hooks/useSearchPlayers';

type Props = {
  option: PlayerSearchOption;
  onSelect: (option: PlayerSearchOption) => void;
};

function shouldUseNativeLink(event: React.MouseEvent<HTMLAnchorElement>) {
  return event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}

const PlayerSearchOptionLink = React.memo(({ option, onSelect }: Props) => {
  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (shouldUseNativeLink(event)) {
        event.stopPropagation();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      onSelect(option);
    },
    [onSelect, option],
  );

  const handleNativeLinkEvent = React.useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
  }, []);

  return (
    <a
      className="PlayerSearchOptionLink"
      href={option.href}
      onAuxClick={handleNativeLinkEvent}
      onClick={handleClick}
      onContextMenu={handleNativeLinkEvent}
    >
      {option.label}
    </a>
  );
});

export default PlayerSearchOptionLink;
